import Vue from 'vue'
import { Component } from 'vue-property-decorator';

@Component
export default class CookieComponent extends Vue {
    public expires = 60 * 60 * 24 * 365;

    public cookieCategories = [{
        key: 'necessary',
        text: this.$t('cookie.cookieCategories.necessary.title'),
        description: this.$t('cookie.cookieCategories.necessary.description'),
        arbitrable: false,
        isActive: true,
        cookies: [{
            name: 'cc_show',
            domain: 'braendz.com',
            description: this.$t('cookie.cookies.cc_show')
        },
        {
            name: 'cc_category_necessary_active',
            domain: 'braendz.com',
            description: this.$t('cookie.cookies.cc_category_necessary_active')
        },
        {
            name: 'cc_category_analytics_active',
            domain: 'braendz.com',
            description: this.$t('cookie.cookies.cc_category_analytics_active')
        },
        {
            name: 'fb_disabled',
            domain: 'braendz.com',
            description: this.$t('cookie.cookies.fb_disabled')
        }]
      },
      {
        key: 'analytics',
        text: this.$t('cookie.cookieCategories.analytics.title'),
        description: this.$t('cookie.cookieCategories.analytics.description'),
        arbitrable: true,
        isActive: this.analyticsActive,
        deactivate: () => this.stopAnalyticServices(),
        activate: () => this.startAnalyticServices(),
        cookies: [{
            name: '_ga',
            domain: 'braendz.com',
            description: this.$t('cookie.cookies.ga')
        },
        {
            name: '_ga_<id>',
            domain: 'braendz.com',
            description: this.$t('cookie.cookies.ga_id')
        }]
      },
    ];

    // Getter:
    public get consentRequired(): boolean {
        const value = this.$cookies.get('cc_show');

        return typeof value === 'boolean' ? value 
            : typeof value === 'string' ? (value === 'true') 
            : true;
    }
    public set consentRequired(value: boolean) {
        this.$cookies.set('cc_show', value, { expires: this.expires });
    }

    public get analyticsActive(): boolean {
        return this.isActive('analytics');
    }
    public set analyticsActive(value: boolean) {
        this.setActive('analytics', value);
    }

    // Methods:
    public isActive(category: string): boolean {
        const value = this.$cookies.get(`cc_category_${category}_active`);

        return typeof value === 'boolean' ? value 
            : typeof value === 'string' ? (value === 'true') 
            : false;
    }
    public setActive(category: string, value: boolean) {
        this.$cookies.set(`cc_category_${category}_active`, value, { expires: this.expires });
    }

    public saveSettings() {
        for(const category of this.cookieCategories) {
            this.setActive(category.key, category.isActive);
        }
    }

    public executeSettings() {
        for(const category of this.cookieCategories) {
            if(category.isActive && category.activate) {
                category.activate(); 
            }
            else if(!category.isActive && category.deactivate) {
                category.deactivate();
            }
        }
    }

    public startAnalyticServices() {
        this.$gtag.optIn();
        this.$gtag.pageview({page_path: this.$router.currentRoute.path});
    }

    public stopAnalyticServices() {
        this.$gtag.optOut();
    }
}
